import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import GroupIcon from '@material-ui/icons/Group'
import ErrorBoundary from '../ErrorBoundary'

/* autocomplete */
function MultipleSelector (optionList, setter) {
  return (
    <div className="">
      <Autocomplete
        multiple
        id="add-list"
        options={optionList}
        getOptionLabel={(option) => option.name}
        defaultValue={[]}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            label="グループに追加する"
            placeholder=""
          />
        )}
        onChange={(e, value) => {
          setter(JSON.stringify(value, ['id']))
        }}
      />
    </div>
  )
}

function SimpleSelector (optionList, setter) {
  return (
    <div className="">
      <Autocomplete
        id="new-group"
        options={optionList}
        getOptionLabel={(option) => `${option.name}【${option.company?.name}】`}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            label="グループを変更する"
            placeholder=""
          />
        )}
        onChange={(e, value) => {
          setter(value ? value.id : 0)
        }}
      />
    </div>
  )
}

export default function ShareGroupDialog (props) {
  const [addList, setAddList] = useState('[]')
  const [newGroup, setNewGroup] = useState(0)

  const {
    sharedGroup,
    shareGroups,
    users,
    postUrl
  } = props

  useEffect(() => {

  }, [])

  function getUsersNotInGroup (users) {
    return users.filter(
      (user) => sharedGroup.share_group_members.findIndex(
        (member) => member.user.id === user.id
      ) === -1
    )
  }

  const dialogBody = (
    <div className="modal-body">
      {sharedGroup
        ? (
        <React.Fragment>
          <div>{`グループ【${sharedGroup.name}】で共有中`}</div>
          <ul className="list-group sg-list bg-light">
            {sharedGroup.share_group_members.map((member) => {
              return (
                <li className="list-group-item flex-column mx-2" key={member.id}>
                  <div>{member.user.name}</div>
                  <small className="float-right">{member.user.email}</small>
                </li>
              )
            })}
          </ul>
          <div className="row mt-2">
            <div className="col-10">{MultipleSelector(getUsersNotInGroup(users), setAddList)}</div>
            <div className="col-2 d-flex align-items-center mt-2">
              <form action={postUrl.add_members} method="POST">
                <input type="text" name="_token" className="d-none" readOnly value={$('meta[name="csrf-token"]').attr('content')} />
                <input type="text" name="add_list" className="d-none" readOnly value={addList} />
                <button type="submit" className="btn bg-theme-primary p-2" disabled={addList === '[]'}>追加</button>
              </form>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-10">{
              SimpleSelector(shareGroups.filter((group) => sharedGroup.id !== group.id), setNewGroup)
            }</div>
            <div className="col-2 d-flex align-items-center mt-2">
              <form action={postUrl.change_group} method="POST">
                <input type="text" name="_token" className="d-none" readOnly value={$('meta[name="csrf-token"]').attr('content')} />
                <input type="text" name="new_group" className="d-none" readOnly value={newGroup} />
                <button type="submit" className="btn bg-theme-primary p-2" disabled={newGroup === 0}>変更</button>
              </form>
            </div>
          </div>
        </React.Fragment>
          )
        : (
        <React.Fragment>
          <div>この契約は現在のアカウントでのみ閲覧可能です。</div>
          <div className="row mt-2">
            <div className="col-10">{
              SimpleSelector(shareGroups.filter((group) => !sharedGroup || sharedGroup.id !== group.id), setNewGroup)
            }</div>
            <div className="col-2 d-flex align-items-center mt-2">
              <form action={postUrl.change_group} method="POST">
                <input type="text" name="_token" className="d-none" readOnly value={$('meta[name="csrf-token"]').attr('content')} />
                <input type="text" name="new_group" className="d-none" readOnly value={newGroup} />
                <button type="submit" className="btn bg-theme-primary p-2" disabled={newGroup === 0}>変更</button>
              </form>
            </div>
          </div>
        </React.Fragment>
          )}

    </div>
  )

  return (
    <React.Fragment>
      <button type="button" className="btn bg-theme-primary float-right ml-2" data-toggle="modal" data-target="#sgModal">
        <GroupIcon />
        <span className='align-middle'>
          {sharedGroup ? `${sharedGroup.share_group_members.length}人で共有中` : 'グループ未設定'}
        </span>
      </button>
      {/* -- 承認ダイアログ -- */}
      <div className="modal fade" id="sgModal" tabIndex="-1" role="dialog" aria-labelledby="sgModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="sgModalLabel">共有設定</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            {dialogBody}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

ShareGroupDialog.propTypes = {
  sharedGroup: PropTypes.object,
  shareGroups: PropTypes.arrayOf(PropTypes.object),
  users: PropTypes.arrayOf(PropTypes.object),
  postUrl: PropTypes.object
}

$('#share-group-dialog').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <ShareGroupDialog {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
